/* tslint:disable */
/* eslint-disable */
/**
 * 80s Conservation Club REST API
 * 80s Conservation Club REST API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: graham@matthewsapps.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  CreateCampsite201Response,
  CreateCampsiteRequest,
  Filter,
  ListAccountsOrderParameterInner,
  ListCampsitesForMember200Response,
  RenameCampsiteRequest,
  UpdateCampsiteGeometryRequest,
  UpdateCampsiteLabelRequest,
} from '../models/index';
import {
    CreateCampsite201ResponseFromJSON,
    CreateCampsite201ResponseToJSON,
    CreateCampsiteRequestFromJSON,
    CreateCampsiteRequestToJSON,
    FilterFromJSON,
    FilterToJSON,
    ListAccountsOrderParameterInnerFromJSON,
    ListAccountsOrderParameterInnerToJSON,
    ListCampsitesForMember200ResponseFromJSON,
    ListCampsitesForMember200ResponseToJSON,
    RenameCampsiteRequestFromJSON,
    RenameCampsiteRequestToJSON,
    UpdateCampsiteGeometryRequestFromJSON,
    UpdateCampsiteGeometryRequestToJSON,
    UpdateCampsiteLabelRequestFromJSON,
    UpdateCampsiteLabelRequestToJSON,
} from '../models/index';

export interface CreateCampsiteOperationRequest {
    createCampsiteRequest: CreateCampsiteRequest;
}

export interface GetCampsiteRequest {
    campsiteID: string;
}

export interface ListCampsitesRequest {
    filters?: Array<Filter>;
    pageNumber?: number;
    pageSize?: number;
    order?: Array<ListAccountsOrderParameterInner>;
}

export interface RenameCampsiteOperationRequest {
    campsiteID: string;
    renameCampsiteRequest: RenameCampsiteRequest;
}

export interface UpdateCampsiteGeometryOperationRequest {
    campsiteID: string;
    updateCampsiteGeometryRequest: UpdateCampsiteGeometryRequest;
}

export interface UpdateCampsiteLabelOperationRequest {
    campsiteID: string;
    updateCampsiteLabelRequest: UpdateCampsiteLabelRequest;
}

/**
 * 
 */
export class CampsitesApi extends runtime.BaseAPI {

    /**
     * Create a campsite
     * Create Campsite
     */
    async createCampsiteRaw(requestParameters: CreateCampsiteOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreateCampsite201Response>> {
        if (requestParameters['createCampsiteRequest'] == null) {
            throw new runtime.RequiredError(
                'createCampsiteRequest',
                'Required parameter "createCampsiteRequest" was null or undefined when calling createCampsite().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWT", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/campsites`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateCampsiteRequestToJSON(requestParameters['createCampsiteRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CreateCampsite201ResponseFromJSON(jsonValue));
    }

    /**
     * Create a campsite
     * Create Campsite
     */
    async createCampsite(requestParameters: CreateCampsiteOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreateCampsite201Response> {
        const response = await this.createCampsiteRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get a campsite
     * Get Campsite
     */
    async getCampsiteRaw(requestParameters: GetCampsiteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreateCampsite201Response>> {
        if (requestParameters['campsiteID'] == null) {
            throw new runtime.RequiredError(
                'campsiteID',
                'Required parameter "campsiteID" was null or undefined when calling getCampsite().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWT", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/campsites/{campsiteID}`.replace(`{${"campsiteID"}}`, encodeURIComponent(String(requestParameters['campsiteID']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CreateCampsite201ResponseFromJSON(jsonValue));
    }

    /**
     * Get a campsite
     * Get Campsite
     */
    async getCampsite(requestParameters: GetCampsiteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreateCampsite201Response> {
        const response = await this.getCampsiteRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * List campsites
     * List Campsites
     */
    async listCampsitesRaw(requestParameters: ListCampsitesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListCampsitesForMember200Response>> {
        const queryParameters: any = {};

        if (requestParameters['filters'] != null) {
            queryParameters['filters'] = JSON.stringify(requestParameters['filters']);
        }

        if (requestParameters['pageNumber'] != null) {
            queryParameters['page[number]'] = requestParameters['pageNumber'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['page[size]'] = requestParameters['pageSize'];
        }

        if (requestParameters['order'] != null) {
            queryParameters['order'] = JSON.stringify(requestParameters['order']);
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWT", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/campsites`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ListCampsitesForMember200ResponseFromJSON(jsonValue));
    }

    /**
     * List campsites
     * List Campsites
     */
    async listCampsites(requestParameters: ListCampsitesRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListCampsitesForMember200Response> {
        const response = await this.listCampsitesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Rename campsite
     * Rename Campsite
     */
    async renameCampsiteRaw(requestParameters: RenameCampsiteOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreateCampsite201Response>> {
        if (requestParameters['campsiteID'] == null) {
            throw new runtime.RequiredError(
                'campsiteID',
                'Required parameter "campsiteID" was null or undefined when calling renameCampsite().'
            );
        }

        if (requestParameters['renameCampsiteRequest'] == null) {
            throw new runtime.RequiredError(
                'renameCampsiteRequest',
                'Required parameter "renameCampsiteRequest" was null or undefined when calling renameCampsite().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWT", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/campsites/{campsiteID}/rename`.replace(`{${"campsiteID"}}`, encodeURIComponent(String(requestParameters['campsiteID']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: RenameCampsiteRequestToJSON(requestParameters['renameCampsiteRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CreateCampsite201ResponseFromJSON(jsonValue));
    }

    /**
     * Rename campsite
     * Rename Campsite
     */
    async renameCampsite(requestParameters: RenameCampsiteOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreateCampsite201Response> {
        const response = await this.renameCampsiteRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update campsite geometry
     * Update Campsite Geometry
     */
    async updateCampsiteGeometryRaw(requestParameters: UpdateCampsiteGeometryOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreateCampsite201Response>> {
        if (requestParameters['campsiteID'] == null) {
            throw new runtime.RequiredError(
                'campsiteID',
                'Required parameter "campsiteID" was null or undefined when calling updateCampsiteGeometry().'
            );
        }

        if (requestParameters['updateCampsiteGeometryRequest'] == null) {
            throw new runtime.RequiredError(
                'updateCampsiteGeometryRequest',
                'Required parameter "updateCampsiteGeometryRequest" was null or undefined when calling updateCampsiteGeometry().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWT", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/campsites/{campsiteID}/geometry`.replace(`{${"campsiteID"}}`, encodeURIComponent(String(requestParameters['campsiteID']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateCampsiteGeometryRequestToJSON(requestParameters['updateCampsiteGeometryRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CreateCampsite201ResponseFromJSON(jsonValue));
    }

    /**
     * Update campsite geometry
     * Update Campsite Geometry
     */
    async updateCampsiteGeometry(requestParameters: UpdateCampsiteGeometryOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreateCampsite201Response> {
        const response = await this.updateCampsiteGeometryRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update campsite label
     * Update Campsite Label
     */
    async updateCampsiteLabelRaw(requestParameters: UpdateCampsiteLabelOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreateCampsite201Response>> {
        if (requestParameters['campsiteID'] == null) {
            throw new runtime.RequiredError(
                'campsiteID',
                'Required parameter "campsiteID" was null or undefined when calling updateCampsiteLabel().'
            );
        }

        if (requestParameters['updateCampsiteLabelRequest'] == null) {
            throw new runtime.RequiredError(
                'updateCampsiteLabelRequest',
                'Required parameter "updateCampsiteLabelRequest" was null or undefined when calling updateCampsiteLabel().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWT", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/campsites/{campsiteID}/label`.replace(`{${"campsiteID"}}`, encodeURIComponent(String(requestParameters['campsiteID']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateCampsiteLabelRequestToJSON(requestParameters['updateCampsiteLabelRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CreateCampsite201ResponseFromJSON(jsonValue));
    }

    /**
     * Update campsite label
     * Update Campsite Label
     */
    async updateCampsiteLabel(requestParameters: UpdateCampsiteLabelOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreateCampsite201Response> {
        const response = await this.updateCampsiteLabelRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
